/* global $ */

const TCAIQuickView = {

    initializaton: function () {
        this.quickView();
    },

    quickView: function () {
        const quickViewButtons = document.querySelectorAll('.tcai-presta-plugin-quick-view');
        if (!quickViewButtons) {
            return
        }

        quickViewButtons.forEach((quickViewButton) => {

            quickViewButton.addEventListener('click', () => {
                const formData = new FormData();
                formData.append('id_product', quickViewButton.getAttribute('id-product'));
                formData.append('id_product_attribute', quickViewButton.getAttribute('id-product-attribute'));
                formData.append('action', 'quickview');

                fetch('/module/tcai_presta_plugin/quickview', {
                    method: 'POST', body: formData,
                }).then(response => response.json())
                    .then(data => {
                        const quickViewModal = document.createElement('div');
                        quickViewModal.innerHTML = data.quickview_html;

                        document.body.append(quickViewModal);

                        TCAIQuickView.displayThumbnail(quickViewModal.querySelectorAll('.js-thumb'), quickViewModal.querySelector('.product-cover'));
                        TCAIQuickView.slideThumbnails(quickViewModal.querySelector('.js-arrow-up'), quickViewModal.querySelector('.js-arrow-down'), quickViewModal.querySelectorAll('.js-thumb'), quickViewModal.querySelector('.product-cover'));
                        TCAIQuickView.selectAttribute(quickViewModal.querySelectorAll('.input-color'), quickViewModal, quickViewButton.getAttribute('id-product'));
                        TCAIQuickView.addTouchSpins(quickViewModal.querySelector('.qty'), quickViewModal.querySelector('.js-product-minimal-quantity'));

                        $('#tcai-quickview-modal-' + quickViewButton.getAttribute('id-product') + '-' + quickViewButton.getAttribute('id-product-attribute')).modal('show');
                    });
            });
        })
    },


    displayThumbnail: function (elements, source) {
        elements.forEach((element) => {
            element.addEventListener('click', () => {

                TCAIQuickView.resetSelectedThumbnails(elements);

                element.classList.add('selected');
                source.querySelector('img').src = element.getAttribute('data-image-large-src');
            });
        });
    },

    resetSelectedThumbnails: function (elements) {
        elements.forEach((image) => {
            image.classList.remove('selected');
        });
    },

    slideThumbnails: function (up, down, images, source) {

        up.addEventListener('click', () => {

            let selectedKey = 0;

            for (let i = 0; i < images.length; i++) {
                if (images[i].classList.contains('selected')) {
                    selectedKey = i;
                    break;
                }
            }

            if (selectedKey === 0) {
                images[selectedKey].classList.remove('selected');
                selectedKey = images.length;
                images[selectedKey - 1].classList.add('selected');
            } else {
                images[selectedKey].classList.remove('selected');
                images[selectedKey - 1].classList.add('selected');
            }

            images[selectedKey - 1].scrollIntoView();

            source.querySelector('img').src = images[selectedKey - 1].getAttribute('data-image-large-src');
        });

        down.addEventListener('click', () => {

            let selectedKey = 0;

            for (let i = 0; i < images.length; i++) {
                if (images[i].classList.contains('selected')) {
                    selectedKey = i;
                    break;
                }
            }

            if (selectedKey === images.length - 1) {
                images[selectedKey].classList.remove('selected');
                selectedKey = -1;
                images[selectedKey + 1].classList.add('selected');
            } else {
                images[selectedKey].classList.remove('selected');
                images[selectedKey + 1].classList.add('selected');
            }

            images[selectedKey + 1].scrollIntoView();

            source.querySelector('img').src = images[selectedKey + 1].getAttribute('data-image-large-src');
        });
    },

    selectAttribute: function (colors, modal, idProduct) {
        colors.forEach((color) => {
            color.addEventListener('click', (event) => {
                event.preventDefault();

                const groupValue = color.getAttribute('value');
                const token = modal.querySelector('input[name="token"]');

                if (!token) {
                    return
                }

                const formData = new FormData();
                formData.append('quickview', 0);
                formData.append('ajax', 1);
                formData.append('action', 'refresh');
                formData.append('id_product', idProduct);
                formData.append('groupData', groupValue);
                formData.append('token', token.value);

                fetch('/module/tcai_presta_plugin/product', {
                    method: 'POST',
                    body: formData,
                }).then(response => response.json())
                    .then(data => {
                        const imagesContainer = modal.querySelector('.js-images-container');
                        const productPrices = modal.querySelector('.js-product-prices');
                        const productCustomization = modal.querySelector('.js-product-customization');
                        const productAddToCart = modal.querySelector('.js-product-add-to-cart');

                        if (imagesContainer) {
                            imagesContainer.innerHTML = data.product_cover_thumbnails;
                            TCAIQuickView.displayThumbnail(imagesContainer.querySelectorAll('.js-thumb'), imagesContainer.querySelector('.product-cover'));

                            if (imagesContainer.nextElementSibling) {
                                const arrows = imagesContainer.nextElementSibling;
                                TCAIQuickView.slideThumbnails(arrows.querySelector('.js-arrow-up'), arrows.querySelector('.js-arrow-down'), imagesContainer.querySelectorAll('.js-thumb'), imagesContainer.querySelector('.product-cover'));
                            }
                        }

                        if (productPrices) {
                            productPrices.innerHTML = data.product_prices;
                        }

                        if (productCustomization) {
                            productCustomization.innerHTML = data.product_customization;
                        }

                        if (productAddToCart) {
                            productAddToCart.innerHTML = data.product_add_to_cart;
                            TCAIQuickView.addTouchSpins(productAddToCart.querySelector('.qty'), {value: data.product_minimal_quantity});
                        }
                    });
            });
        });
    },

    addTouchSpins: function (element, minimum_quantity) {
        if (!element) {
            return
        }

        const mainDiv = document.createElement('div');
        mainDiv.classList.add('input-group', 'bootstrap-touchspin');

        const spanOne = document.createElement('span');
        spanOne.classList.add('input-group-addon', 'bootstrap-touchspin-prefix');
        spanOne.style = "display: none";

        mainDiv.append(spanOne);

        const numberInput = document.createElement('input');
        numberInput.type = "number";
        numberInput.name = "qty";
        numberInput.id = "quantity_wanted";
        numberInput.inputMode = "numeric";
        numberInput.pattern = "[0-9]*";
        numberInput.setAttribute('value', minimum_quantity.value);
        numberInput.min = 1;
        numberInput.classList.add('input-group', 'form-control');
        numberInput.style = "display: block";

        mainDiv.append(numberInput);

        const spanTwo = document.createElement('span');
        spanTwo.classList.add('input-group-addon', 'bootstrap-touchspin-postfix');
        spanTwo.style = "display: none";

        mainDiv.append(spanTwo);

        const spanThree = document.createElement('span');
        spanThree.classList.add('input-group-btn-vertical');

        const buttonOne = document.createElement('button');
        buttonOne.classList.add('btn', 'btn-touchspin', 'js-touchspin', 'bootstrap-touchspin-up');
        buttonOne.setAttribute('type', 'button');

        buttonOne.addEventListener('click', () => {
            numberInput.value = parseInt(numberInput.value) + 1;
        });

        const iOne = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        iOne.setAttribute('width', '10');
        iOne.setAttribute('height', '6');
        iOne.setAttribute('viewBox', '0 0 10 6');
        iOne.setAttribute('fill', 'none');
        iOne.innerHTML = '<rect width="10" height="6" fill="#F5F5F5"/>\n' +
            '<g id="Denon - desktop - szybki podgl&#196;&#133;d" clip-path="url(#clip0_0_1)">\n' +
            '<rect width="1665" height="2270" transform="translate(-1040 -596)" fill="white"/>\n' +
            '<rect id="Rectangle 4" x="-1040" y="-596" width="1665" height="2577" fill="#2C3E4C" fill-opacity="0.2"/>\n' +
            '<g id="Frame 43">\n' +
            '<rect x="-737" y="-493" width="1060" height="614" rx="5" fill="white"/>\n' +
            '<g id="Frame 42">\n' +
            '<g id="Frame 40">\n' +
            '<g id="Frame 38">\n' +
            '<g id="ilosc">\n' +
            '<g id="up down">\n' +
            '<rect x="-4.5" y="-6" width="19" height="18" rx="4.5" fill="white"/>\n' +
            '<rect x="-4.5" y="-6" width="19" height="18" rx="4.5" stroke="#FF8A02"/>\n' +
            '<path id="Vector" d="M7.72741 6L9.36377 4.36364L5.00013 -3.81481e-07L0.636497 4.36364L2.27286 6L5.00013 3.27273L7.72741 6Z" fill="#FF8A02"/>\n' +
            '</g>\n' +
            '</g>\n' +
            '</g>\n' +
            '</g>\n' +
            '</g>\n' +
            '</g>\n' +
            '</g>\n' +
            '<defs>\n' +
            '<clipPath id="clip0_0_1">\n' +
            '<rect width="1665" height="2270" fill="white" transform="translate(-1040 -596)"/>\n' +
            '</clipPath>\n' +
            '</defs>';
        buttonOne.append(iOne);

        const buttonTwo = document.createElement('button');
        buttonTwo.classList.add('btn', 'btn-touchspin', 'js-touchspin', 'bootstrap-touchspin-down');
        buttonTwo.setAttribute('type', 'button');

        buttonTwo.addEventListener('click', () => {
            const actualNumber = isNaN(parseInt(numberInput.value)) ? 1 : parseInt(numberInput.value)

            if (actualNumber > parseInt(minimum_quantity.value)) {
                numberInput.value = parseInt(numberInput.value) - 1;
            }
        });

        const iTwo = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        iTwo.setAttribute('width', '10');
        iTwo.setAttribute('height', '6');
        iTwo.setAttribute('viewBox', '0 0 10 6');
        iTwo.setAttribute('fill', 'none');
        iTwo.innerHTML = '<path id="Vector" d="M2.27259 2.86111e-07L0.63623 1.63636L4.99987 6L9.3635 1.63637L7.72714 1.23981e-06L4.99987 2.72727L2.27259 2.86111e-07Z" fill="#FF8A02"/>';
        buttonTwo.append(iTwo);

        spanThree.append(buttonOne);
        spanThree.append(buttonTwo);

        mainDiv.append(spanThree);

        element.innerHTML = '';
        element.appendChild(mainDiv);
    },
}

export default TCAIQuickView;